import { axiosInstance as axios } from "../axios-provider";

import { ErrorHandler } from "../error-handler";
import { Message } from "../../chat/Message";
import { HttpHeaders } from "../../../../utils/http-utils";

export class CopilotService {
  private readonly config: {
    baseURL: string;
    timeout: number;
    headers: HttpHeaders;
  };

  constructor(
    private baseURL: string,
    private enabled: boolean
  ) {
    this.config = {
      baseURL: this.baseURL,
      timeout: 50000,
      headers: {
        "Content-Type": "application/json",
      },
    };
  }

  errorHandler = new ErrorHandler("Copilot Service");

  private readonly apiUrlCopilot = "api/copilot";

  async prompt(prompt: string, context?: Message[]): Promise<Message> {
    const payload = { prompt: prompt, context: context };
    return axios
      .post(this.apiUrlCopilot, payload, this.config)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        throw this.errorHandler.handle(error, "copilot-service");
      });
  }

  isEnabled(): boolean {
    return this.enabled;
  }
}
